import { useMutation } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";

export const useDeleteSector = () => {
  const { authHeader } = useAuth();
  return useMutation(({ id }: { id: number }) => {
    return axios.delete(
      `${env.verifyServiceUrl}individual/business_sector_risk_level/${id}/`,
      {
        headers: {
          Authorization: authHeader,
        },
      }
    );
  });
};
